export default __webpack_public_path__ + "static/media/promo_code_icon.048dffd2.svg";